import settings from "@/settings.json";

export const getContentFullUrl = (contentStorageName: string) => {
  if (contentStorageName?.startsWith("http")) {
    return contentStorageName;
  }
  return `${settings.ContentSource}${contentStorageName}`;
};

export const getIsEndDatePassed = (endDate: string) => {
  const isEndDatePassed = endDate ? new Date().getTime() > new Date(endDate + "Z").getTime() : false;
  return isEndDatePassed;
};

export const getIsStartDatePassed = (startDate: string) => {
  const isStartDatePassed = startDate ? new Date().getTime() < new Date(startDate + "Z").getTime() : false;
  return isStartDatePassed;
};

export const getIsEndDateExpiringSoon = (endDate: string) => {
  const endDaysExpiringSoon = 3;

  if (!endDate) {
    return false;
  }

  const now = new Date().getTime();
  const endDateTime = new Date(endDate + "Z").getTime();
  const daysInMs = endDaysExpiringSoon * 24 * 60 * 60 * 1000;

  // Check if end date is in the future but within the expiring soon threshold
  return endDateTime > now && endDateTime <= now + daysInMs;
};
